import Vue from 'vue';
import VueRouter from 'vue-router';
import {routes} from '@/router/routes.js';
import {NProgress} from '@/util/nprogress.js';
Vue.use(VueRouter);
//获取登录状态
import commons from '@/util/commons.js';
//引入加载条
let router = new VueRouter({
	mode:'history',
	scrollBehavior(to,from,savedPosition){
		if(savedPosition){
			return savedPosition;
		}else if(to.hash){
			return {selector: to.hash};
		}else{
			return {x:0,y:0};
		}
	},
	routes
})
router.beforeEach((to, from, next) => {
	NProgress.configure({parent: 'body'});
	console.log(to.path,to.meta.noNProgress);
	if(!to.meta.noNProgress){
		NProgress.start();
	}
	let localUser = commons.readTodos('localUser');
	console.log(localUser,'=======================');
	// console.log(to.meta.requireAuth,!localUser.token);
	if(to.meta.requireAuth && !localUser.token){
		// next();
		//未登录则跳转登陆页面
		next({name:'login'});
	}else{
		next(); // 确保一定要调用 next()
	}
})
router.afterEach(transition => {
    NProgress.done();
});
export default router;


// WEBPACK FOOTER //
// ./src/router/index.js